var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSponsor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_6899_300243)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6899_300243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65363 4.29693C7.23956 3.10972 7.53252 2.51611 7.99874 2.51611C8.46496 2.51611 8.75792 3.10972 9.34384 4.29693L9.53904 4.69245C9.71 5.03885 9.79548 5.21205 9.94526 5.32087C10.095 5.42969 10.2862 5.45746 10.6684 5.51301L11.1049 5.57643C12.4151 5.76681 13.0702 5.862 13.2142 6.3054C13.3583 6.7488 12.8843 7.21086 11.9362 8.13497L11.6204 8.44284C11.3438 8.71247 11.2055 8.84729 11.1483 9.02337C11.0911 9.19944 11.1237 9.38981 11.189 9.77054L11.2636 10.2053C11.4874 11.5101 11.5993 12.1626 11.2221 12.4366C10.8449 12.7106 10.259 12.4026 9.08715 11.7865L8.69675 11.5813C8.35483 11.4015 8.18387 11.3116 7.99874 11.3116C7.8136 11.3116 7.64264 11.4015 7.30073 11.5813L6.91033 11.7865C5.73848 12.4026 5.15256 12.7106 4.77538 12.4366C4.3982 12.1626 4.5101 11.5101 4.7339 10.2053L4.80846 9.77054C4.87376 9.38981 4.90641 9.19944 4.8492 9.02337C4.79199 8.84729 4.65368 8.71247 4.37707 8.44284L4.06123 8.13497C3.11318 7.21086 2.63916 6.7488 2.78323 6.3054C2.9273 5.862 3.58238 5.76681 4.89255 5.57643L5.32903 5.51301C5.7113 5.45746 5.90244 5.42969 6.05222 5.32087C6.202 5.21205 6.28747 5.03885 6.45843 4.69245L6.65363 4.29693Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6899_300243",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6899_300243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor);
export default __webpack_public_path__ + "static/media/sponsor.0eb39b65.svg";
export { ForwardRef as ReactComponent };